import {
  Component,
  ContentChild,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteActivatedEvent,
  MatAutocompleteTrigger,
  MatOption
} from '@angular/material/autocomplete';
import {MatIcon} from '@angular/material/icon';
import {MatFormField, MatSuffix} from '@angular/material/form-field';
import {NgForOf, NgIf, NgTemplateOutlet} from '@angular/common';
import {MatLabel} from '@angular/material/select';
import {MatInput} from '@angular/material/input';
import {MatIconButton} from '@angular/material/button';

@Component({
  selector: 'pas-multi-select2',
  standalone: true,
  imports: [
    MatAutocompleteTrigger,
    ReactiveFormsModule,
    MatAutocomplete,
    MatOption,
    MatIcon,
    MatLabel,
    MatFormField,
    NgIf,
    NgForOf,
    MatInput,
    NgTemplateOutlet,
    MatIconButton,
    MatSuffix
  ],
  templateUrl: './multi-select2.component.html',
  styleUrl: './multi-select2.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelect2Component),
      multi: true
    }
    ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiSelect2Component<T extends {id: number, name: string}> implements OnInit, OnChanges{
  inputControl = new FormControl('');
  _options: T[] = [];
  public isAutocompleteOpen: boolean = false;


  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  @Input() label: string = '';
  @Input({required: true}) set options(v: T[]){
    this._options = v;
    this.filteredOptions = this._options;
  };
  @Output() input = new EventEmitter<string>();
  @ContentChild('optionTemplate') optionTemplateRef!: TemplateRef<any>; // Шаблон для отображения в списке опций
  @ContentChild('selectedTemplate') selectedTemplateRef!: TemplateRef<any>; // Шаблон для отображения выбранных элементов

  filteredOptions: T[] = [];
  selectedOptions: T[] = [];

  private onChange = (value: any) => {};
  public onTouched = () => {};

  ngOnInit() {
    this.filteredOptions = this._options;
    this.inputControl.valueChanges.subscribe(value => {
      this.filteredOptions = this.filterOptions(value);
    });
  }

  ngOnChanges(changes:SimpleChanges) {
    // this.filteredOptions = this._options;
    // console.log('changes', changes);
  }

  filterOptions(value: string|null): T[] {
    if(value===null || value===undefined) return [];
    const filterValue = typeof value === 'string' ? value.toLowerCase() :this.getOptionText(value).toLowerCase();
    return this._options?.length && this._options.filter(option => this.getOptionText(option).toLowerCase().includes(filterValue)) || [];
  }

  onInput() {
    const inputValue = this.inputControl!.value;
    this.filteredOptions = this.filterOptions(inputValue);
    this.input.emit(inputValue||'');
  }

  onOptionSelected(event: any) {
    const selected = event.option.value as T;
    if (!this.selectedOptions.find(opt => this.compareOptions(opt, selected))) {
      this.selectedOptions.push(selected);
    }
    this.onChange(this.selectedOptions);
    this.inputControl.setValue('');
  }

  remove(option: T) {
    this.selectedOptions = this.selectedOptions.filter(o => !this.compareOptions(o, option));
    this.onChange(this.selectedOptions);
  }

  getSelectedText(): string {
    return this.selectedOptions.map(opt => this.getOptionText(opt)).join(', ');
  }

  // Методы для ControlValueAccessor
  writeValue(value: T[]): void {
    if (value) {
      this.selectedOptions = value;
    } else {
      this.selectedOptions = [];
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.inputControl.disable();
    } else {
      this.inputControl.enable();
    }
  }

  // Функция для получения текстового представления объекта
  private getOptionText(option: T): string {
    if(!option) return '';
    return (option as any).name || JSON.stringify(option); 
  }

  // Функция для сравнения объектов (по id или другому полю)
  private compareOptions(opt1: T, opt2: T): boolean {
    return (opt1 as any).id === (opt2 as any).id; // Пример сравнения по id
  }

  toggleAutocomplete(event: MouseEvent): void {
    event.stopPropagation();
    this.isAutocompleteOpen ?this.autocompleteTrigger.closePanel():this.autocompleteTrigger.openPanel();
    this.isAutocompleteOpen = !this.isAutocompleteOpen;
  }

  onOptionActivated($event: MatAutocompleteActivatedEvent): void {
    // console.log('MatAutocompleteActivatedEvent',$event);
  }
}
